const _treatAsUTC = (date) => {
    const result = new Date(date);
    result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
    return result;
}

const dateFromISODate = (isodate) => {
    const parts = isodate.split('-').map((el, i) => {
        el = Number(el)
        if (i ===  1) el = el - 1
        return el
    })

    return new Date(...parts)
}

const dateToISODate = (date) => {
    date = new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
    return date.toISOString().split('T')[0]
}

const dateToISOTime = (date) => {
    date = new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
    return date.toISOString().split('T')[1].slice(0, 5);
}

const dateFromTimestamp = (timestamp) => {
    const date = new Date(Number(timestamp) * 1000)
    date.setMinutes(date.getMinutes() + date.getTimezoneOffset())
    return date
}

const isoDateFromTimestamp = (timestamp) => {
    return dateToISODate(dateFromTimestamp(timestamp))
}

const isoTimeFromTimestamp = (timestamp) => {
    return dateToISOTime(dateFromTimestamp(timestamp))
}

const dateDifference = (d1, d2) => {
    
    const utc1 = _treatAsUTC(d1)
    const utc2 = _treatAsUTC(d2)

    return (utc2 - utc1)/(1000 * 60 * 60 * 24)
}

const isoDateDifference = (iso1, iso2) => {
    const d1 = dateFromISODate(iso1)
    const d2 = dateFromISODate(iso2)
    
    return dateDifference(d1, d2)
}

const hexToRgb = (hex) => {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
    hex = hex.replace(shorthandRegex, (m, r, g, b)  => r + r + g + g + b + b)

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)

    return result
    ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)]
    : null
}

const rgbToHex = (r, g, b) => {
    return '#' + [r, g, b].reduce((prev, curr) => {
        const hex = curr.toString(16)
        prev += hex.length == 1 ? "0" + hex : hex
        return prev
    }, '')
}

const getTextColor = (hex, rgb=null) => {
    if (rgb === null) rgb = hexToRgb(hex)

    if((rgb[0]*0.299)+(rgb[1]*0.587)+(rgb[2]*0.114)>160) {
        return 'black'
    } else {
        return 'white'
    }
}

export {
    dateFromISODate,
    dateToISODate,
    dateFromTimestamp,
    isoDateFromTimestamp,
    isoTimeFromTimestamp,
    dateDifference,
    isoDateDifference,
    hexToRgb,
    rgbToHex,
    getTextColor,
}